<table mat-table [dataSource]="dataSource" class="mat-elevation-z8 demo-table">
    <ng-container matColumnDef="system">
        <th mat-header-cell *matHeaderCellDef>Método</th>
        <td mat-cell *matCellDef="let element">
            <button [matMenuTriggerFor]="systemsMenu" class="container-system-resume">
                <app-system-picture class="system-picture" [systemId]="element.system.id"
                    [alt]="element.system.attributes.name"
                    title="Comprar/Vender {{element.system.attributes.name}}"></app-system-picture>
                <app-system-icon [systemId]="element.system.id" [alt]="element.system.attributes.name"
                    title="Comprar/Vender {{element.system.attributes.name}}"></app-system-icon>
                <mat-icon>expand_more</mat-icon>
            </button>
            <mat-menu #systemsMenu="matMenu" class="container-system-mat-menu">
                <button *ngFor="let system of objectKeys(objectSystems)"
                    (click)="changeSystemAndCalculateSystem(element.system_id, objectSystems[system])" mat-menu-item
                    class="system-mat-menu">
                    <app-system-picture class="system-picture" [systemId]="objectSystems[system].id"
                        [alt]="objectSystems[system].name"
                        title="Comprar/Vender {{objectSystems[system].name}}"></app-system-picture>
                </button>
            </mat-menu>
        </td>
    </ng-container>

    <ng-container matColumnDef="buy" sticky>
        <th mat-header-cell *matHeaderCellDef>Compra</th>
        <td mat-cell *matCellDef="let element">
            <p>{{element.buy.amount}} <span>{{element.buy.currency}}</span></p>
            <p class="text-time-average">Promedio de tiempo: {{element.buy.time_average}} hs</p>
        </td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
            <div class="quotation-on-action">
                <p>{{element.buy.amount}} <span>{{element.buy.currency}}</span></p>
                <p>{{element.sell.amount}} <span>{{element.sell.currency}}</span></p>
            </div>
            <div class="button-buy-sell">
                <button [routerLink]="element.action.buy" mat-button>Comprar</button>
                <div class="btn-system">
                    <app-system-icon systemId="{{system.id}}" title="{{system.attributes.name}}"
                        alt="{{system.attributes.name}}" size="small" width="36" height="36">
                    </app-system-icon>
                </div>
                <button [routerLink]="element.action.sell" mat-button>Vender</button>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="sell">
        <th mat-header-cell *matHeaderCellDef>Venta</th>
        <td mat-cell *matCellDef="let element">
            <p>{{element.sell.amount}} <span>{{element.sell.currency}}</span></p>
            <p class="text-time-average" *ngIf="element.sell.time_average">Tiempo promedio: {{element.sell.time_average}} hs</p>
        </td>
    </ng-container>

    <ng-container matColumnDef="disclaimer">
        <td mat-footer-cell *matFooterCellDef colspan="5" class="last-row">
            <div class="demo-button-container">
                <a (click)="addSystemDataToDisplay()" class="rs-link demo-button">
                    + Agregar
                </a>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="more-info">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon class="more-icon">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <a mat-menu-item class="flex-row-start-center more-link" *ngFor="let link of moreLinks; first as isFirst"
                    routerLink="{{link.url + (isFirst ? element.system.id +'-a-'+ system.id : element.system.id)}}"
                    title="{{link.title}}">
                    {{link.title}}
                </a>
                <a mat-menu-item (click)="removeSystemFromTable(element.system.id)"
                    class="flex-row-start-center more-link">Quitar</a>
            </mat-menu>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="['disclaimer']" class="example-second-footer-row"></tr>
</table>
